import {
  TransfersState,
  TransfersAction,
  TransfersActionTypes,
} from './transfersTypes'

const initialState: TransfersState = {
  loadingTransfers: true,
  savingTransfer: false,
  removingTransfer: false,
  transfers: [],
  selectedIndex: null,
  isEditing: false,
  filters: {
    dateFrom: '',
    dateTo: '',
  },
}

export default function transfersReducer(
  state = initialState,
  action: TransfersAction
): TransfersState {
  switch (action.type) {
    case TransfersActionTypes.EDITING_START:
      return {
        ...state,
        isEditing: true,
        selectedIndex: action.index ?? null,
      }

    case TransfersActionTypes.EDITING_CANCEL:
      return {
        ...state,
        isEditing: false,
      }

    case TransfersActionTypes.GET_TRANSFERS_START:
      return {
        ...state,
        loadingTransfers: true,
      }

    case TransfersActionTypes.GET_TRANSFERS_SUCCESS:
      if (!action.transfers) {
        throw new Error()
      }
      return {
        ...state,
        loadingTransfers: false,
        transfers: action.transfers,
      }

    case TransfersActionTypes.GET_TRANSFERS_ERROR:
      return {
        ...state,
        loadingTransfers: false,
      }

    case TransfersActionTypes.SAVE_TRANSFER_START:
      return {
        ...state,
        savingTransfer: true,
      }

    case TransfersActionTypes.SAVE_TRANSFER_SUCCESS:
      return {
        ...state,
        savingTransfer: false,
        selectedIndex: null,
      }

    case TransfersActionTypes.SAVE_TRANSFER_ERROR:
      return {
        ...state,
        savingTransfer: false,
      }

    case TransfersActionTypes.REMOVE_TRANSFER_START:
      return {
        ...state,
        removingTransfer: true,
      }

    case TransfersActionTypes.REMOVE_TRANSFER_SUCCESS:
      return {
        ...state,
        removingTransfer: false,
        selectedIndex: null,
        isEditing: false,
      }

    case TransfersActionTypes.REMOVE_TRANSFER_ERROR:
      return {
        ...state,
        removingTransfer: false,
      }

    case TransfersActionTypes.SET_FILTERS:
      if (!action.filters) {
        throw new Error()
      }
      return {
        ...state,
        filters: action.filters,
      }

    case TransfersActionTypes.CLEAR:
      return initialState

    default:
      return state
  }
}
